module.exports = __webpack_public_path__ + "media/images/new-ui-images/force-trigger-9a8786bc6b678cc3c3c509b861240f33.svg";